export default "__VITE_ASSET__Dt179lCK__"